/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitacoesPendentesDetalhesAliases {
  ACTION_ADD_FILE = 'action-add-file',
  ACTION_ALTERAR_DATA_VALIDADE = 'action-alterar-data-validade',
  ACTION_ASSUMIR_ANALISE = 'action-assumir-analise',
  ACTION_PARECER = 'action-parecer',
  ACTION_PESQUISA_UTILIZACAO = 'action-pesquisa-utilizacao',
  ACTION_PRINT = 'action-print',
  ATTACHMENTS_LIST = 'attachments-list',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_ANEXOS = 'fetch-anexos',
  FETCH_DADOS = 'fetch-dados',
  FETCH_ITENS = 'fetch-itens',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_GUIA = 'field-guia',
  FIELD_OBSERVACAO = 'field-observacao',
  FIELD_REQUISICAO = 'field-requisicao',
  FIELD_TOAST = 'field-toast',
  FILE_UPLOADER_MODAL = 'file-uploader-modal',
  FORM_DADOS = 'form-dados',
  FORM_ITENS = 'form-itens',
  HPMS_GUIA_ANALISE_ITENS = 'hpms-guia-analise-itens',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  INPUT_8 = 'input-8',
  INPUT_9 = 'input-9',
  INPUT_10 = 'input-10',
  INPUT_11 = 'input-11',
  INPUT_12 = 'input-12',
  INPUT_13 = 'input-13',
  LAYOUT_SOLICITACOES_PENDENTES_DETALHES = 'layout-solicitacoes-pendentes-detalhes',
  MAPPER_23 = 'mapper-23',
  MAPPER_ANEXOS = 'mapper-anexos',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_ANEXOS = 'panel-anexos',
  PANEL_FILE_UPLOADER_MODAL = 'panel-file-uploader-modal',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_0 = 'text-area-0',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { SolicitacoesPendentesDetalhesAliases };
